<table [hidden]="!itemsLoaded" class="table table-sm table-hover orders padding">
  <thead>
    <tr>
      <th *ngIf="userPreferences.display.IDdisplay">ID</th>
      <th class="order ps-4">
        {{'project.order'|translate}}<br />
        {{'order.worktype'|translate}}
      </th>
      <th>
        {{'entity.recipe'|translate}}<br/>
        &nbsp;
      </th>
      <th class="production">
        {{'order.production'|translate}}{{'datetime.date'|translate|lowercase}}<br />
        <span class="time">{{'order.starttime'|translate}}</span>
        <span class="time">{{'order.loadtime'|translate}}</span>
        <span class="time">{{'order.endtime'|translate}}</span>
      </th>
      <th class="produced">
        {{'production.produced'|translate}}<br />
        &nbsp;
      </th>
      <th class="unloading-method">
        {{'order.unloading-method'|translate}}<br />
        &nbsp;
      </th>
      <th class="notes"><i class="fas fa-comments"></i></th>
      <th class="actions">&nbsp;</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of items" (click)="edit(item.id)">
      <td *ngIf="userPreferences.display.IDdisplay">
        {{IDPrefix}}{{item.id}}
      </td>
      <td class="ps-4">
        {{item.description}}<br />
        {{item.worktype.description}}
      </td>
      <td>
        <span *ngIf="!item.recipe" class="text-muted">{{'order.recipe-unknown'|translate}}</span>
        <jbm-link-button *ngIf="item.recipe" [caption]="" [showIcon]="false" class="recipe-link"
          (onClick)="showRecipe(item.recipe.id, item.concrete_specs.environment ? item.concrete_specs.environment.description : '')">
              <jbm-label-with-ID [ID]="item.recipe.public_id" [label]="item.recipe.code" [IDPosition]="userPreferences.display.IDdisplay"></jbm-label-with-ID>
        </jbm-link-button>
        <button *ngIf="item.recipe_comments" type="button" class="btn btn-sm btn-link comments-link"
          [ngbTooltip]="item.recipe_comments" container="body" placement="right" (click)="$event.stopPropagation()">
            <i class="far fa-comment-alt"></i>
        </button>
      </td>
      <td>
        {{item.production_date}}<br />
        <span class="time">
          <span *ngIf="item.starttime"><i class="fa-clock far text-muted"></i>{{item.starttime}}</span>
          <span *ngIf="!item.starttime">-</span>
        </span>
        <span class="time">
          <span *ngIf="item.loadtime"><i class="fa-clock far text-muted"></i>{{item.loadtime}}</span>
          <span *ngIf="!item.loadtime">-</span>
        </span>
        <span class="time">
          <span *ngIf="item.endtime"><i class="fa-clock far text-muted"></i>{{item.endtime}}</span>
          <span *ngIf="!item.endtime">-</span>
        </span>
      </td>
      <td>
        <div class="amount-value">{{item.amountProgress}}</div>
        <ngb-progressbar class="order-progress" type="success" [value]="item.completed"></ngb-progressbar>
      </td>
      <td>
        {{item.unloading_method.description}}<br />
        {{item.unloadingMethodFlow}}
      </td>
      <td>
        <jbm-comments-dropdown [comments]="item.comments"></jbm-comments-dropdown>
      </td>
      <td>
        <button [disabled]="!item.articles_count" type="button" tabindex="-1"
          class="btn btn-sm btn-link action-link"
          popoverClass="order-articles-list" container="body" placement="left" [ngbPopover]="popContent"
          [popoverTitle]="('project.order'|translate)+' '+('financial.articles'|translate|lowercase)"
          (click)="$event.stopPropagation()">
            {{'financial.articles'|translate}}
            <span *ngIf="item.articles_count" class="badge bg-light text-dark">{{item.articles_count}}</span>
        </button>
        <ng-template #popContent>
            <order-articles-list [orderID]="item.id"></order-articles-list>
        </ng-template>
        <button *ngIf="item.production_date && editable && item.unloading_flow" type="button"
          class="btn btn-sm btn-link action-link"
          container="body" placement="top" ngbTooltip="{{'project.order'|translate}} {{'ui.copy'|translate|lowercase}}"
          (click)="copy(item); $event.stopPropagation()">
            {{'ui.copy'|translate}}
        </button>
        <button *ngIf="editable" type="button" class="btn btn-sm btn-link action-link"
          container="body" placement="top" ngbTooltip="{{'ui.edit-tooltip'|translate}}"
          (click)="edit(item.id); $event.stopPropagation()">
            <i class="far fa-edit"></i>
        </button>
        <jbm-confirm-delete-dropdown *ngIf="!item.inProduction && editable && item.delivered==0"
          placement="top-right" (onConfirm)="deleteItem(item.id)"
          [subject]="('project.order'|translate)+' '+('ui.delete'|translate|lowercase)" [class]="'float-end ms-3'">
        </jbm-confirm-delete-dropdown>
      </td>
    </tr>
  </tbody>
</table>

<jbm-toasts></jbm-toasts>

<jbm-modal [id]="'amount'" [className]="'amount'"></jbm-modal>
<ng-template #modalAmount let-modal>
    <order-amount-form [order_id]="id" (onSave)="onSaveAmountDialog()" (onCancel)="onCancelAmountDialog()"></order-amount-form>
</ng-template>

<jbm-modal [id]="'copy'" [className]="'copy'"></jbm-modal>
<ng-template #modalCopy let-modal>
    <order-copy [order_id]="id" (onSave)="onSaveCopy()" (onCancel)="onCancelCopy()"></order-copy>
</ng-template>

<jbm-modal [id]="'recipe'" [className]="'invoice-recipe'"></jbm-modal>
<ng-template #modalRecipe let-modal>
    <recipe-details [plant_id]="plants_id" [recipe_id]="recipe_id" [environment]="environment" (onClose)="closeRecipe()"></recipe-details>
</ng-template>
